import { Navigate } from 'react-router-dom';
import { auth } from '../services';
import { getHomePathForRole, normalizeRole } from '../utils/roles';

/**
 * RoleRoute - Allows access when the signed-in user has one of the allowed roles.
 */
const RoleRoute = ({ children, allowedRoles = [] }) => {
  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = auth.getUser();
  if (!user) {
    auth.clearAuth();
    return <Navigate to="/login" replace />;
  }

  const userRole = normalizeRole(user.role);
  const allowed = allowedRoles.map(normalizeRole);

  if (!allowed.includes(userRole)) {
    return <Navigate to={getHomePathForRole(userRole)} replace />;
  }

  return children;
};

export default RoleRoute;
